import { useQuery } from '@tanstack/react-query';
import { api } from '../client';
import { queryKeys } from '../query-keys';

export function useMarketComponentsForValidationSelect(
  marketId: string | undefined,
  enabled: boolean = true
) {
  return useQuery({
    queryKey: queryKeys.marketComponents.forValidation(marketId),
    enabled: enabled && !!marketId,
    queryFn: async () => {
      const res =
        await api.marketComponentApi.apiMarketComponentsForValidationMarketIdGetCollection(
          marketId!
        );
      return res.data;
    },
    meta: {
      skipGlobalError: false,
    },
  });
}
